import { createSlice } from "@reduxjs/toolkit";

import { getChefDetailByIds } from "../../../../api/chef";
import { sliceHandler } from "../../utils";

const getChefDetailById = createSlice(
  sliceHandler({
    name: 'getChefDetailById',
    action: 'getChefDetailByIdSlice',
    success: 'getChefDetailByIdSliceSuccess',
    failure: 'getChefDetailByIdSliceFailure',
    reset: 'getChefDetailByIdSliceReset'
  })
);

const getChefDetailByIdAction: any = getChefDetailById.actions;
const getChefDetailByIdHandler: any = (id: any) => async (dispatch: any) => {
  try {
    dispatch(getChefDetailByIdAction.getChefDetailByIdSlice());
    const response: any = await getChefDetailByIds(id);
    dispatch(getChefDetailByIdAction.getChefDetailByIdSliceSuccess(response));
  } catch (e: any) {
    dispatch(getChefDetailByIdAction.getChefDetailByIdSliceFailure(e?.response?.data));
  }
};

export {
  getChefDetailByIdAction,
  getChefDetailByIdHandler,
}
export default getChefDetailById.reducer;